import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'admin/components/atoms/Buttons';
import Img from 'admin/components/atoms/Img';
import { OAuthClientHeaders, Row, RowCell } from './OAuthClientHeaders';
import {
  allowedGrantTypeOptions,
  defaultScopeOptions,
  creatingAccountTypeOptions,
  concealUserExistenceOptions,
} from './constants';

const ModalWrapper = styled.div`
  width: 1000px;
  max-height: calc(100vh - 210px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
    border-left: solid 1px #ececec;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
    box-shadow: inset 0 0 0 2px #fff;
  }
`;

const CancelButton = styled(Button)`
  background-color: gray;
  margin-left: 10px;
`;

const ConfirmButton = styled(Button)`
  background-color: red;
  margin-left: 10px;
`;

// 未知の値もそのまま表示する。確認画面は送信内容を見せる場所なので、ここで伏せると
// オペレータが知らないまま保存され、しかも保存後に気づく手段がなくなる
const labelOf = (options, value) => options.find(o => o.value === value)?.labelText ?? value;

const OAuthClientConfirmModal = ({ form, onConfirm, onCancel, imgPreview, updateClientSecret }) => (
  <ModalWrapper>
    <Row>
      <OAuthClientHeaders keyName="name" />
      <RowCell>{form.name}</RowCell>
    </Row>
    {updateClientSecret !== null
     ? (
       <Row>
         <OAuthClientHeaders keyName="client_secret" />
         <RowCell>{updateClientSecret === true ? '更新する' : '更新しない'}</RowCell>
       </Row>
     )
     : null}
    <Row>
      <OAuthClientHeaders keyName="redirect_uri" />
      <RowCell>{form.redirect_uri}</RowCell>
    </Row>
    <Row>
      <OAuthClientHeaders keyName="allowed_grant_types" />
      <RowCell>
        {form.allowed_grant_types.map(v => labelOf(allowedGrantTypeOptions, v)).join(', ')}
      </RowCell>
    </Row>
    <Row>
      <OAuthClientHeaders keyName="default_scopes" />
      <RowCell>
        {form.default_scopes.map(v => labelOf(defaultScopeOptions, v)).join(', ')}
      </RowCell>
    </Row>
    <Row>
      <OAuthClientHeaders keyName="organization" />
      <RowCell>
        {form.organization.label == null ? form.organization.name : form.organization.label}
      </RowCell>
    </Row>
    <Row>
      <OAuthClientHeaders keyName="creating_account_type" />
      <RowCell>
        {creatingAccountTypeOptions.find(c => (
          c.value === form.creating_account_type.toLowerCase()
        )).label}
      </RowCell>
    </Row>
    {form.creating_account_type.toLowerCase() === 'one'
     ? (
       <Row>
         <OAuthClientHeaders keyName="default_private_money" />
         <RowCell>
           {form.default_private_money !== null ? form.default_private_money.name : '指定しない'}
         </RowCell>
       </Row>
     ) : null}
    <Row>
      <OAuthClientHeaders keyName="description" />
      <RowCell>{form.description}</RowCell>
    </Row>
    <Row>
      <OAuthClientHeaders keyName="oauth_client_image" />
      <Img
        src={imgPreview !== null ? imgPreview : form.oauth_client_image}
        alt=""
        height="100px"
        style={{ padding: '10px' }}
      />
    </Row>
    <Row>
      <OAuthClientHeaders keyName="conceal_user_existence" />
      <RowCell>{concealUserExistenceOptions.find(op => op.value === form.conceal_user_existence)?.label}</RowCell>
    </Row>
    <div style={{ textAlign: 'center', margin: 10 }}>
      <CancelButton onClick={onCancel}>キャンセル</CancelButton>
      <ConfirmButton onClick={onConfirm}>実行</ConfirmButton>
    </div>
  </ModalWrapper>
);

OAuthClientConfirmModal.defaultProps = {
  imgPreview: null,
  updateClientSecret: null,
};

OAuthClientConfirmModal.propTypes = {
  form: PropTypes.object.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  imgPreview: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  updateClientSecret: PropTypes.bool,
};

export default OAuthClientConfirmModal;
